import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import Adam3p from "../../images/imgs/3p-adam.webp";
import Design3 from "../../images/imgs/design-3.webp";

import { Pagination } from "swiper/modules";

const MainSlider = () => {
  return (
    <section className="intro">
      <div className="social-media-links">
        <div className="social">
          <a href="/" target="blanck">
            <span>IN</span>
            <p>INSTAGRAM</p>
          </a>
        </div>
        <div className="social">
          <a href="/" target="blanck">
            <span>TW</span>
            <p>TWITTER</p>
          </a>
        </div>
        <div className="social">
          <a href="/" target="blanck">
            <span>FB</span>
            <p>FACEBOOK</p>
          </a>
        </div>
      </div>
      <Swiper
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        className="mySwiper"
      >
        <SwiperSlide>
          <div className="container">
            <div className="info-wraper">
              <h3>ADAM Foodstuffs</h3>
              <p>
                30 Years of Innovation
                <br />
                at Your
                <span>Fingertips!</span>
              </p>
              <div className="work-with">
                <Link to="/about">Discover Now</Link>
              </div>
            </div>

            <div className="slide-img">
              <img loading="lazy" src={Adam3p} alt="slide-img" />
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="container">
            <div className="info-wraper">
              <h3>ADAM Foodstuffs</h3>
              <p>
                Adam's Products your wise choice for the
                <span>well-being</span>
              </p>
              <div className="work-with">
                <Link to="/about">Discover Now</Link>
              </div>
            </div>

            <div className="slide-img">
              <img loading="lazy" src={Design3} alt="slide-img" />
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
};

export default MainSlider;
